var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg403(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.87,333.4C187.58,354,250.34,335.85,300.47,312c200.39-74.1,78.11-251.63-59.05-244.18S-20.74,270.6,135.87,333.4Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.87,333.4C187.58,354,250.34,335.85,300.47,312c200.39-74.1,78.11-251.63-59.05-244.18S-20.74,270.6,135.87,333.4Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-136"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-136",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.84,355.75h126.4a10.92,10.92,0,0,0,11-11.72L238.61,123a12.68,12.68,0,0,0-12.44-11.72H99.76a10.93,10.93,0,0,0-11,11.72L102.4,344A12.66,12.66,0,0,0,114.84,355.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,191h1.84a2.4,2.4,0,0,0,2.42-2.58l-2.06-33.33a2.78,2.78,0,0,0-2.74-2.58H90.67a2.41,2.41,0,0,0-2.43,2.58l2.06,33.33A2.79,2.79,0,0,0,93,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8,169.73H243a2.33,2.33,0,0,0,2.34-2.5L244.43,153a2.69,2.69,0,0,0-2.65-2.5h-2.16a2.33,2.33,0,0,0-2.35,2.5l.88,14.23A2.71,2.71,0,0,0,240.8,169.73Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.37,195.15h2.17a2.33,2.33,0,0,0,2.34-2.5L246,178.42a2.69,2.69,0,0,0-2.65-2.5h-2.17a2.33,2.33,0,0,0-2.34,2.5l.88,14.23A2.7,2.7,0,0,0,242.37,195.15Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.63,
    y: 107.81,
    width: 14.54,
    height: 1,
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.72,
    y: 107.81,
    width: 4.22,
    height: 1,
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.79,355.75H243.2a10.93,10.93,0,0,0,11-11.72L240.56,123a12.66,12.66,0,0,0-12.44-11.72H101.72a10.92,10.92,0,0,0-11,11.72l13.63,221A12.68,12.68,0,0,0,116.79,355.75Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.93 342.4 251.42 342.4 238.01 125.06 93.52 125.06 106.93 342.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.66,232h-5.12c-2.69-28.12-26.93-50.84-55.11-51.64l-.34-5.13a1.67,1.67,0,0,0-1.64-1.54,1.42,1.42,0,0,0-1.43,1.54l.34,5.13c-28.07.8-49.27,23.52-48.19,51.64h-5.12a1.43,1.43,0,0,0-1.44,1.54,1.67,1.67,0,0,0,1.64,1.54h5.13c2.68,28.12,26.92,50.84,55.1,51.64l.34,5.13a1.67,1.67,0,0,0,1.64,1.54,1.43,1.43,0,0,0,1.44-1.54l-.35-5.13c28.07-.8,49.27-23.52,48.19-51.64h5.13a1.42,1.42,0,0,0,1.43-1.54A1.66,1.66,0,0,0,230.66,232Zm-53.31,51.65-.34-5.05a1.67,1.67,0,0,0-1.64-1.54,1.42,1.42,0,0,0-1.43,1.54l.33,5.05c-26.48-.8-49.25-22.14-51.82-48.57h5a1.42,1.42,0,0,0,1.43-1.54,1.66,1.66,0,0,0-1.64-1.54h-5c-1-26.43,18.94-47.77,45.32-48.57l.33,5.05a1.68,1.68,0,0,0,1.64,1.54,1.43,1.43,0,0,0,1.44-1.54l-.34-5.05c26.48.8,49.25,22.14,51.82,48.57h-5.05a1.42,1.42,0,0,0-1.43,1.54,1.67,1.67,0,0,0,1.64,1.54h5C223.64,261.5,203.72,282.84,177.35,283.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.71,218.61l0-.08a1.11,1.11,0,0,0-.07-.16l-.07-.08a1.31,1.31,0,0,0-.11-.12.31.31,0,0,0-.09-.07l-.09-.08h0l0,0-30.09-15.05a1,1,0,0,0-.92,0L141.8,218l0,0h0l-.09.08a.5.5,0,0,0-.08.07.54.54,0,0,0-.09.12l-.06.08a1,1,0,0,0-.06.16l0,.08a.82.82,0,0,0,0,.27l1.86,32.47a1.08,1.08,0,0,0,.6.89l30.09,15.05h0a.92.92,0,0,0,.42.1.8.8,0,0,0,.41-.1h.05l28.36-15.05a.94.94,0,0,0,.49-.89l-1.87-32.47A.86.86,0,0,0,201.71,218.61Zm-45.15-6.13L184.4,226.4l-12.06,6.41-27.85-13.93ZM170.74,205l27.84,13.93-12.06,6.4-27.85-13.93ZM143.4,220.52l28,14,1.73,30.22-28-14Zm58.19,30.22-26.42,14-1.73-30.22,12.24-6.49.34,5.88a1.07,1.07,0,0,0,1,1,.94.94,0,0,0,1-1l-.4-6.91,12.24-6.5Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.92,116.73H149.59a1,1,0,0,0-1,1.08l0,.72a1.18,1.18,0,0,0,1.16,1.09H181.1a1,1,0,0,0,1-1.09l-.05-.72A1.17,1.17,0,0,0,180.92,116.73Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.19,188.74l-.61.13-.5.1-1,.15c-.63.08-1.24.15-1.85.2-1.23.1-2.43.14-3.64.14a42.86,42.86,0,0,1-7.16-.67,44.54,44.54,0,0,1-6.92-1.8c-1.12-.39-2.23-.83-3.31-1.32l-.82-.36-.51-.24a7.59,7.59,0,0,1-.93-.51,8.47,8.47,0,0,1-2.59-2.63,12.44,12.44,0,0,1-1.68-4.75,25.68,25.68,0,0,1-.27-3.9,45.08,45.08,0,0,1,.69-6.95,71.64,71.64,0,0,1,3.46-12.83l5.37,1.28c-.32,4.09-.63,8.3-.66,12.3a42.82,42.82,0,0,0,.28,5.77,15,15,0,0,0,.45,2.42,2.47,2.47,0,0,0,.56,1.17s-.08-.2-.35-.4l-.23-.14c-.08,0,0,0,.06,0l.17.06.67.21c.88.3,1.8.52,2.7.76a41.06,41.06,0,0,0,5.49,1,44.66,44.66,0,0,0,5.53.3c.92,0,1.84,0,2.73-.1.45,0,.89-.08,1.32-.13l.62-.07.28,0,.16,0Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.16,155.84l-.26-7.49,7.42-.8s1.58,7.63-3.33,9.56Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.76,144.28l3.23-.19a2,2,0,0,1,2.08,1.69l.25,1.77-7.42.8v-2.09A2,2,0,0,1,321.76,144.28Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65,191.94c-5.11,4.82-26.52-2.86-26.52-2.86l5.41-12.94A60.41,60.41,0,0,1,347,174.92C357.45,175.33,358.26,186.66,352.65,191.94Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.18,150.89c.6,2.62.06,4.88-1.2,5s-2.77-1.83-3.37-4.45-.06-4.87,1.2-5S317.58,148.27,318.18,150.89Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.31 153.46 316.98 155.93 314.81 146.45 328.47 145.42 330.31 153.46",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.16,149.21c.51,2.22.13,4.12-.85,4.25s-2.18-1.57-2.68-3.79-.13-4.13.84-4.25S330.65,147,331.16,149.21Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.16,149.21c.51,2.22.13,4.12-.85,4.25s-2.18-1.57-2.68-3.79-.13-4.13.84-4.25S330.65,147,331.16,149.21Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.06,147.1l-3.93.17c-.57.07-.81,1.09-.54,2.27s1,2.08,1.52,2l3.78-.82c.43-.06.59-.92.36-1.92S333.49,147,333.06,147.1Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.06,147.1l-3.93.17c-.57.07-.81,1.09-.54,2.27s1,2.08,1.52,2l3.78-.82c.43-.06.59-.92.36-1.92S333.49,147,333.06,147.1Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.45,151.76c.6,2.62.06,4.88-1.2,5s-2.77-1.83-3.36-4.45-.07-4.87,1.19-5S310.85,149.14,311.45,151.76Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.59 154.33 310.25 156.8 308.08 147.32 321.75 146.29 323.59 154.33",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,150.08c.5,2.22.12,4.12-.85,4.25s-2.18-1.57-2.69-3.79-.13-4.13.85-4.25S323.93,147.86,324.44,150.08Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,150.08c.5,2.22.12,4.12-.85,4.25s-2.18-1.57-2.69-3.79-.13-4.13.85-4.25S323.93,147.86,324.44,150.08Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.33,148l-3.92.17c-.57.07-.81,1.09-.54,2.27s.95,2.08,1.52,2l3.77-.82c.43-.06.6-.92.37-1.92S326.76,147.91,326.33,148Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.33,148l-3.92.17c-.57.07-.81,1.09-.54,2.27s.95,2.08,1.52,2l3.77-.82c.43-.06.6-.92.37-1.92S326.76,147.91,326.33,148Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.8,149.23c-.1.59-.5,1-.88.93s-.6-.59-.5-1.18.5-1,.88-.93S327.91,148.65,327.8,149.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.36,150.24a21,21,0,0,1-3.69,4.49,3.42,3.42,0,0,0,2.7,1Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.52,146.38a.38.38,0,0,1-.26-.11,2.76,2.76,0,0,0-2.35-.88.36.36,0,0,1-.41-.28.35.35,0,0,1,.28-.41,3.45,3.45,0,0,1,3,1.09.35.35,0,0,1-.24.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.52,157c-.93,5.4-1.75,15.27,2.09,18.77,0,0-1.35,5.48-11.33,5.71-11,.25-5.37-5.33-5.37-5.33,6-1.57,5.7-6,4.56-10.16Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.46,408.38c-.94,0-1.85-.13-2.16-.56a.65.65,0,0,1,0-.76.87.87,0,0,1,.55-.41c1.22-.33,3.79,1.14,3.9,1.2a.18.18,0,0,1,.08.18.17.17,0,0,1-.14.14A13,13,0,0,1,286.46,408.38ZM285.3,407a1.18,1.18,0,0,0-.34,0,.51.51,0,0,0-.34.24c-.12.22-.08.33,0,.39.35.47,2.2.48,3.57.29A7.88,7.88,0,0,0,285.3,407Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.68,408.17h-.07c-.89-.4-2.64-2-2.51-2.82,0-.19.17-.44.65-.49a1.3,1.3,0,0,1,1,.3c.94.77,1.13,2.75,1.14,2.83a.17.17,0,0,1-.07.16A.17.17,0,0,1,288.68,408.17Zm-1.79-3h-.11c-.31,0-.33.16-.34.2-.08.49,1.12,1.74,2,2.29a4,4,0,0,0-1-2.27A.92.92,0,0,0,286.89,405.19Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.76 408 289.41 408 288.68 390.99 296.03 390.99 296.76 408",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.46,407.15h8a.65.65,0,0,1,.63.5l1.45,6.53a1.07,1.07,0,0,1-1.06,1.31c-2.89-.05-7.07-.22-10.71-.22-4.25,0-7.93.23-12.91.23-3,0-3.86-3.05-2.6-3.33,5.75-1.25,10.44-1.39,15.41-4.45A3.44,3.44,0,0,1,289.46,407.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.66,178.46s-7.62,9,1,63.49l39.29-.89c.11-5.28-3.28-28.4-.67-53.22a10.81,10.81,0,0,0-10.15-12l-1.52-.05a142.2,142.2,0,0,0-16.7.38A73.49,73.49,0,0,0,318.66,178.46Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.66,178.46s.87-.26,2.29-.62c4.33.35,6.54,5.27,5.5,10.45-.77,3.86-6.23,9.24-10.88,13.21C315.25,182.5,318.66,178.46,318.66,178.46Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,188.74c-.55.13-.83.17-1.2.24l-1,.17c-.68.08-1.36.15-2,.19-1.34.11-2.65.14-4,.12a44.18,44.18,0,0,1-7.79-.91,48.45,48.45,0,0,1-7.48-2.25l-1.78-.78-1.05-.47a6.94,6.94,0,0,1-2.47-2,6.87,6.87,0,0,1-1.3-2.75,8,8,0,0,1-.18-2.19,11.38,11.38,0,0,1,.58-2.92,23.26,23.26,0,0,1,1.84-4,38.36,38.36,0,0,1,2.06-3.25c1.43-2,2.92-3.95,4.48-5.77a114.61,114.61,0,0,1,9.9-10.29l4.13,3.65c-2.56,3.76-5.13,7.6-7.53,11.4-1.18,1.92-2.34,3.83-3.35,5.73-.5.95-1,1.89-1.38,2.79a13.74,13.74,0,0,0-.86,2.45c-.07.31-.06.57,0,.49a1.06,1.06,0,0,0,0-.45,2.91,2.91,0,0,0-.56-1.2,3.32,3.32,0,0,0-1.1-.91c-.15-.06,0,0,0,0l.19.06.36.11,1.47.46a45.4,45.4,0,0,0,6,1.26,42.44,42.44,0,0,0,6.05.43c1,0,2,0,3-.08.5,0,1-.09,1.45-.14l1.18-.14Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.47,191.94c-5.11,4.82-26.52-2.86-26.52-2.86l5.41-12.94s9.81-.19,18.89,0C337.47,176.46,334.08,186.66,328.47,191.94Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,155.49l-.26-7.49,7.42-.8s1.58,7.63-3.33,9.56Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.51,144.93l4-.18a1.35,1.35,0,0,1,1.38,1.64l-.19.81-7.42.8,1.08-2.29A1.32,1.32,0,0,1,313.51,144.93Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.68 390.99 289.06 399.76 296.41 399.76 296.03 390.99 288.68 390.99",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.48,151.49c-1.73,7.08-2.38,11.32-6.66,14.34-6.44,4.56-14.69-.31-15.11-7.77-.38-6.71,2.51-17.17,10-18.76A10,10,0,0,1,347.48,151.49Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.56,152.22c-2.61-1.72-1-8.61-.45-9.94a3.86,3.86,0,0,1-2.22.33s2.56-5.08,9.89-3.54,11.22,7,9.67,12.16-4.06,11.71-7.56,12.16S331.39,161.39,332.56,152.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.91,148c-2.62-2.68-8.93-7.61-8.71-9.22.39-2.82,8.46-4.66,15.08,5.68C341.22,149.06,335.12,151.29,331.91,148Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.91,148c-2.62-2.68-8.93-7.61-8.71-9.22.39-2.82,8.46-4.66,15.08,5.68C341.22,149.06,335.12,151.29,331.91,148Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,143.13a1.7,1.7,0,0,0,.22,1.47,30.84,30.84,0,0,0,6.09,6.63c4.34,3.52,11.38,4.06,13.34,3.69,1.6-.31,2.7-5.82,3.06-7.82a2.32,2.32,0,0,0-.19-1.4c-.77-1.63-3-5.7-6.51-7.27s-8.84-1.37-10.95-1.23a2.37,2.37,0,0,0-1.56.74A15.78,15.78,0,0,0,329,143.13Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.25,152l-.75,1.76a24.52,24.52,0,0,0,5.81.65,11.51,11.51,0,0,1,.86,1.87,4.11,4.11,0,0,0,0-3.48A28.88,28.88,0,0,1,343.25,152Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.86,153.12a8.32,8.32,0,0,1-3.54,3.94c-2.09,1.14-3.31-.44-2.88-2.56.39-1.92,1.94-4.82,4.11-5.1S337.69,151.1,336.86,153.12Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.63,408.38a3.27,3.27,0,0,1-2.25-.56.68.68,0,0,1-.12-.76.69.69,0,0,1,.48-.41c1.17-.33,4,1.14,4.11,1.2a.22.22,0,0,1,.11.18.13.13,0,0,1-.11.14A12.51,12.51,0,0,1,359.63,408.38ZM358.22,407a1.15,1.15,0,0,0-.33,0,.42.42,0,0,0-.3.24.36.36,0,0,0,0,.39c.43.47,2.29.48,3.62.29A9.12,9.12,0,0,0,358.22,407Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.81,408.17h-.07c-.95-.4-3-2-3-2.82,0-.19.09-.44.56-.49a1.52,1.52,0,0,1,1,.3A6.08,6.08,0,0,1,362,408a.18.18,0,0,1,0,.16A.17.17,0,0,1,361.81,408.17Zm-2.3-3h-.1c-.31,0-.31.16-.31.2,0,.49,1.41,1.74,2.41,2.29a5,5,0,0,0-1.36-2.27A1.09,1.09,0,0,0,359.51,405.19Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.99 408 362.65 408 358.18 390.99 365.52 390.99 369.99 408",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.42,407.15h8a.79.79,0,0,1,.71.5l2.58,6.53a.9.9,0,0,1-.84,1.31c-2.9-.05-7.11-.22-10.75-.22-4.25,0-7.88.23-12.87.23-3,0-4.38-3.05-3.16-3.33,5.53-1.25,10.2-1.39,14.64-4.45A2.92,2.92,0,0,1,362.42,407.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.18 390.99 360.75 400.77 367.83 399.76 365.53 390.99 358.18 390.99",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,241.68s-12.54,55.86-8.74,78.28c4,23.31,34.16,78.1,34.16,78.1l11.91-1.53s-17.24-62.36-24-78c5-46.31,15.39-54.65,13.56-77.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.55,260.15a3.33,3.33,0,0,0-2-.81c-1.81,5.1-3.82,10.83-5.86,16.69-1,6.76-1.92,13.84-2.48,20.55C331.47,281.5,338.93,264.57,333.55,260.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.92,394.21c-.05,0,2.25,4.92,2.25,4.92l15-2-1-4.52Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.66,242S284,295.22,283.92,317.64c-.05,23.32,2.4,80.42,2.4,80.42h12.44s8.52-57.26,7.52-81.89c9.44-19.47,25.41-42.13,34.11-57.73a52.34,52.34,0,0,0,6-17.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.93,393.1c-.06,0,.7,5.17.7,5.17h15.14l.41-4.61Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.36,176.06c3.54,1.26,12.23,16.64-8.41,27.46a1.47,1.47,0,0,0-.79,1.26c-.1,10.26.24,24,1,30.09a1.45,1.45,0,0,0,1.65,1.25c17-2.5,33.82-2.61,40.29-2a1.45,1.45,0,0,0,1.59-1.57c-.89-9.37-1.89-30.64-.73-39.07,1.25-9,.66-13.28-3.67-17a10.54,10.54,0,0,0-9-2.5s-14.17,1.09-15.41,1.17A51.15,51.15,0,0,0,324.36,176.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.72,174.83l1.8-.1a.5.5,0,0,1,.49.31c1.25,3,11.27,26.3,26.47,26.77a.49.49,0,0,1,.49.47c0,.75,0,1.47,0,1.91a.5.5,0,0,1-.45.48c-2.64.26-17.08.24-29.24-29.14A.51.51,0,0,1,329.72,174.83Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.45,145.51l-1.46-.45.48-1.54-2-.62-10.2,33-1.35-.41a2.23,2.23,0,0,0-2.8,1.47l-7.54,24.41a2.33,2.33,0,0,0-.7-.36c-1.88-.58-4.08,1.16-4.92,3.86s0,5.38,1.88,6a2.65,2.65,0,0,0,.79.11L341,216.3a2.23,2.23,0,0,0,1.47,2.8l1.93.6a1.49,1.49,0,0,0,1.86-1l6.29-20.37,6.3-20.37,8.66-28ZM342.11,210c-1.38-.43-2-2.64-1.29-4.84s2.41-3.7,3.79-3.27a1.75,1.75,0,0,1,.68.43l-1.57,5.09a5.37,5.37,0,0,1-1.38-1.83.45.45,0,0,0-.58-.24.46.46,0,0,0-.24.59,6,6,0,0,0,1.93,2.38l-.53,1.71A1.7,1.7,0,0,1,342.11,210Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.45,145.51l-1.46-.45.48-1.54-2-.62-10.2,33-1.35-.41a2.23,2.23,0,0,0-2.8,1.47l-7.54,24.41a2.33,2.33,0,0,0-.7-.36c-1.88-.58-4.08,1.16-4.92,3.86s0,5.38,1.88,6a2.65,2.65,0,0,0,.79.11L341,216.3a2.23,2.23,0,0,0,1.47,2.8l1.93.6a1.49,1.49,0,0,0,1.86-1l6.29-20.37,6.3-20.37,8.66-28ZM342.11,210c-1.38-.43-2-2.64-1.29-4.84s2.41-3.7,3.79-3.27a1.75,1.75,0,0,1,.68.43l-1.57,5.09a5.37,5.37,0,0,1-1.38-1.83.45.45,0,0,0-.58-.24.46.46,0,0,0-.24.59,6,6,0,0,0,1.93,2.38l-.53,1.71A1.7,1.7,0,0,1,342.11,210Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.22,173.39h2.08a1.57,1.57,0,0,1,1.57,1.57v22.78a3.13,3.13,0,0,1-3.13,3.13h-.53a1,1,0,0,1-1-1V174.43a1,1,0,0,1,1-1Z",
    transform: "translate(632.2 469.62) rotate(-162.84)",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.22,173.39h2.08a1.57,1.57,0,0,1,1.57,1.57v22.78a3.13,3.13,0,0,1-3.13,3.13h-.53a1,1,0,0,1-1-1V174.43a1,1,0,0,1,1-1Z",
    transform: "translate(632.2 469.62) rotate(-162.84)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.17,211.68l5.41,1.67a1.45,1.45,0,0,1,1,1.82L347.35,219a1.65,1.65,0,0,1-.21.42l-5.58,7.79a1.47,1.47,0,0,0,0,1.69,3.29,3.29,0,0,1,.51,2.9c-.62,2-6.25,18.16-8.22,22.75a1.46,1.46,0,0,1-1.47.87c-3.48-.25-7.24-2.08-9.27-3.21a1.45,1.45,0,0,1-.39-2.2c3.23-3.81,12.43-14.82,13.15-17.39.54-1.92-.51-2.62-1.4-2.88a1.42,1.42,0,0,1-1-1.44l.07-1.87a1.4,1.4,0,0,1,.44-1c1-.9,3.47-3.91,6.38-12.85A1.45,1.45,0,0,1,342.17,211.68Z",
    style: {
      fill: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.17,211.68l5.41,1.67a1.45,1.45,0,0,1,1,1.82L347.35,219a1.65,1.65,0,0,1-.21.42l-5.58,7.79a1.47,1.47,0,0,0,0,1.69,3.29,3.29,0,0,1,.51,2.9c-.62,2-6.25,18.16-8.22,22.75a1.46,1.46,0,0,1-1.47.87c-3.48-.25-7.24-2.08-9.27-3.21a1.45,1.45,0,0,1-.39-2.2c3.23-3.81,12.43-14.82,13.15-17.39.54-1.92-.51-2.62-1.4-2.88a1.42,1.42,0,0,1-1-1.44l.07-1.87a1.4,1.4,0,0,1,.44-1c1-.9,3.47-3.91,6.38-12.85A1.45,1.45,0,0,1,342.17,211.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.91,215.36c.55,3.27-.56,11.73.78,12.94s9.56-.2,10.55-.85-.09-12.31-.31-13.77S317.75,214.39,317.91,215.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.27,214.56c1-1.29,11.39-2.46,11.72-1.41s-3.29,5-6.57,5.31S316.31,215.86,317.27,214.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.27,214.56c1-1.29,11.39-2.46,11.72-1.41s-3.29,5-6.57,5.31S316.31,215.86,317.27,214.56Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.7b783301d708fde09981586b1d3b3190.svg";
export { ForwardRef as ReactComponent };